export default {
    categories: {
        'product-variation': {
            title: window.i18n.__('Déclinaisons produit'),
            subtitle: window.i18n.__('Données déclinaisons produit'),
        },
    },
    rows: [
        {
            category: 'product-variation',
            label: window.i18n.__('Identifiant Produit'),
            description: {
                text: window.i18n.__('Récupéré depuis un export produits Sellsy'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Identifiant déclinaison'),
            description: {
                text: window.i18n.__('Récupéré depuis un export de déclinaisons produit Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Référence produit'),
            description: {
                text: window.i18n.__('Référence ou code du produit auquel sera ajoutée la déclinaison'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Référence déclinaison'),
            description: {
                text: window.i18n.__('Référence de la déclinaison produit à ajouter'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Nom commercial'),
            description: {
                text: window.i18n.__('Nom commercial de la déclinaison produit')
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Si la cellule est vide, alors le nom commercial sera généré automatiquement suivant le règle : [Nom produit parent] [valeur de la variation 1] [valeur de la variation 2][valeur de la variation 3]'),
            mandatoryTooltipClass: 'w-240',
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code déclinaison 1'),
            description: {
                text: window.i18n.__('Code du premier critère de déclinaison'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Code du critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “color” pour le critère de déclinaison “couleur”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code valeur déclinaison 1'),
            description: {
                text: window.i18n.__('Code d’une valeur du premier critère de déclinaison')
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Code de la valeur du premier critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “red” pour la valeur “rouge” du critère de déclinaison “couleur”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code déclinaison 2'),
            description: {
                text: window.i18n.__('Code du deuxième critère de déclinaison'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code du critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “size” pour le critère de déclinaison “taille”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code valeur déclinaison 2'),
            description: {
                text: window.i18n.__('Code d’une valeur du deuxième critère de déclinaison')
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code de la valeur du deuxième critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “large” pour la valeur “L” du critère de déclinaison “taille”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code déclinaison 3'),
            description: {
                text: window.i18n.__('Code du troisième critère de déclinaison')
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code du critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “material” pour le critère de déclinaison “matière”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Code valeur déclinaison 3'),
            description: {
                text: window.i18n.__('Code d’une valeur du troisième critère de déclinaison'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code de la valeur du troisième critère de déclinaison parmi la liste existante'),
                subtext: window.i18n.__('Ex : “wood” pour la valeur “bois” du critère de déclinaison “matière”')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Prix vente HT'),
            description: {
                text: window.i18n.__('Prix de vente hors taxe de la déclinaison')
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Si ce champ n’est pas renseigné alors le prix d’achat HT du produit parent sera appliqué'),
            mandatoryTooltipClass: 'w-264',
            value: {
                text: window.i18n.__('Numérique (2 décimales)')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Prix achat HT'),
            description: {
                text: window.i18n.__('Prix d’achat hors taxe de la déclinaison')
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Si ce champ n’est pas renseigné alors le prix d’achat HT du produit parent sera appliqué'),
            mandatoryTooltipClass: 'w-264',
            value: {
                text: window.i18n.__('Numérique (2 décimales)')
            },
        },
        {
            category: 'product-variation',
            label: window.i18n.__('Description'),
            description: {
                text: window.i18n.__('Description de la déclinaison')
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique')
            },
        },
    ],
};
